'use client';

import { useEffect, useState } from 'react';

export function ElectronTitleBar() {
  const [isElectron, setIsElectron] = useState(false);
  const [isMax, setIsMax] = useState(false);
  const [platform, setPlatform] = useState('');

  useEffect(() => {
    const isElectronUa = typeof navigator !== 'undefined' && /Electron/i.test(navigator.userAgent || '');
    const hasElectronApi = typeof window !== 'undefined' && !!(window as any).electronAPI;
    const hasElectron = isElectronUa && hasElectronApi;
    
    setIsElectron(hasElectron);
    if (hasElectron) {
      setPlatform((window as any).electronAPI.platform);
      document.body.classList.add('electron-shell');
      try {
        setIsMax(!!(window as any).electronAPI.isMaximized?.());
      } catch {
      }
    } else {
      document.body.classList.remove('electron-shell');
    }

    return () => {
      document.body.classList.remove('electron-shell');
    };
  }, []);

  if (!isElectron) return null;

  const isMac = platform === 'darwin';

  const onMinimize = () => {
    const hasPopOutHandler = (window as any).togglePopOutForMinimize;
    if (hasPopOutHandler) {
      hasPopOutHandler();
    } else {
      (window as any).electronAPI?.minimizeWindow?.();
    }
  };
  const onMaximize = () => {
    (window as any).electronAPI?.maximizeWindow?.();
    setTimeout(() => {
      try {
        setIsMax(!!(window as any).electronAPI.isMaximized?.());
      } catch {
      }
    }, 120);
  };
  const onClose = () => (window as any).electronAPI?.closeWindow?.();

  return (
    <div className={`electron-titlebar ${isMac ? 'electron-titlebar-mac' : ''}`}>
      {isMac && <div className="electron-titlebar-mac-spacer" />}
      
      <div className="electron-titlebar-drag">
        <img src="/images/logo.png" alt="MeetX" className="electron-titlebar-logo" />
        <span>MeetX</span>
      </div>

      {!isMac && (
        <div className="electron-titlebar-actions">
          <button className="electron-titlebar-btn" onClick={onMinimize} aria-label="Minimize">−</button>
          <button className="electron-titlebar-btn" onClick={onMaximize} aria-label="Maximize">{isMax ? '❐' : '□'}</button>
          <button className="electron-titlebar-btn electron-titlebar-btn-close" onClick={onClose} aria-label="Close">×</button>
        </div>
      )}
    </div>
  );
}
